import React from 'react';

import Container from 'components/Container';
import Page from 'layout/Page';
import Heatmap from 'components/Heatmap';

const Home = () => {
  return (
    <Page title="Home">
      <Container center maxWidth="xl">
        <Heatmap />
      </Container>
    </Page>
  );
};

export default Home;
